/**
 * For when you want an array and don't want code that is hard to read later.
 * @param {*} maybeAnArray
 * @returns {Array}
 */
const makeItAnArray = (maybeAnArray) => [].concat(maybeAnArray || []);

export default makeItAnArray;
